import React, { Component } from 'react';
import './Home.scss'
import { Link } from 'react-router-dom'
import {Helmet} from "react-helmet"
import WOW from 'wowjs'
import Banner from '../../Components/Banner'

class Home extends Component {

    componentDidMount() {
        new WOW.WOW({
			mobile: false,
        }).init();
        window.scrollTo(0,0)
    }
    
    render() {
        return (
			<div className="home-page">
				<Helmet>
					<title>GPbook | Specialist Directory - Referrals made Quick & Easy</title>
					<meta name="description" content="GPbook is the online Medical & Surgical Specialist Referral Directory, used by GPs for over 20 years to look up specialist details such as speciality, special interests, clinics and hospitals. General Practitioners have access to direct contact details of specialists allowing for quick and easy referrals." />
				</Helmet>	
				<NewBanner />
                <GPvsSP />
                <Services />
            </div>
        );
    }
}

const NewBanner = () => 
	<div className="new-banner">
		<div className="text-center">
			<img src={require('./mssd.svg')} alt="GPbook Specialist Directory MSSRD" height="280"  />
			<div className="options">
				<h1 >
                    {/* The Medical & Surgical Specialist Directory (WA) {`${new Date().getFullYear()}`} */}
                    The Medical & Surgical Specialist Directory (WA) 2024
					<span  data-wow-delay="0.75s">is now available online & in-print</span>
				</h1>
				<Link to="/features" className="btn">Features</Link>
				<Link to="/purchase" className="btn secondary inverse">Purchase</Link>
				
			</div>

			<div className="browser-mockup with-url">
				<img src={require('./gpbook.gif')} alt="test" width="100%" />	
				{/* <div className="video-holder">
					<video autoPlay loop >
						<source src={require('./video.webm')} type="video/webm" />
						<source src={require('./video.mp4')} type="video/mp4" />
						Your browser does not support the video tag.
					</video>
				</div> */}
			</div>
			
		</div>
	</div>



// const Banner = () =>
//     <div className="banner">
//         <div className="container">
//             <div className="row">
//                 <div className="col-md-3">
//                     <div className="book  wow zoomIn" data-wow-duration="1s">
//                         <img src={require('./mssd.svg')} alt="GPbook Specialist Directory MSSRD" height="340" />
//                     </div>    
//                 </div>
//                 <div className="col-md-6">
//                     <div className="welcome wow fadeInDown" data-wow-delay="0.5s" >Welcome to<br />the online edition of the</div>
//                     <h2 className="mssd wow fadeIn" data-wow-delay="1s"  >Medical & Surgical Specialist Referral Directory by Stephen Hodby</h2>
//                     <div className="options">
//                         <Link to="/purchase" className="btn inverse wow bounceIn" data-wow-delay="2s">Subscribe Now</Link>
// 						<Link to="/pricing" className="btn wow bounceIn" data-wow-delay="2.2s">Pricing Details</Link>
// 						<p className="m-t-1 wow zoomIn" data-wow-delay="2.4s">Join free for a month.</p>
//                         {/* <Link to="/update" className="btn wow bounceIn" data-wow-delay="2.4s">Update Your Details</Link> */}
//                     </div>
//                 </div>
                

//                 <div className="col-md-3 video">
//                     <div className="holder wow fadeInRight" data-wow-delay="1.25s" >
//                         <img src={require('./laptop.png')} alt="laptop gpbook" />
//                         <div className="video-holder">
//                             <video autoPlay loop >
//                                 <source src={require('./video.webm')} type="video/webm" />
//                                 <source src={require('./video.mp4')} type="video/mp4" />
//                                 Your browser does not support the video tag.
//                             </video>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>   


const GPvsSP = () =>
    <div className="container gp-vs-sp">

        <h2 className="zoomIn" data-wow-delay="1s" style={{marginTop: 30,marginBottom:45}}>Connecting Specialists with General Practice</h2>
        <div className="row">
            <div className="col-md-5  fadeInRight" data-wow-delay="1.5s">
                <h3>Specialist Listings</h3>
                <p>List your details privately on the directory. You can list Special Interests, Clinics, Hospitals, as well as contact details so that GPs can refer patients to your service.</p>
                <br />
                <Link to="/listing" className="btn"><i className="fa fa-users" />Apply to be Listed</Link>
                <ul>
                    <li>
                        <b>Patient Referrals</b>
                        <p>Boost your referrals</p>
                    </li>
                    <li>
                        <b>General Practice Visibility</b>
                        <p>GPs can find out more about you</p>
                    </li>
                    <li>
                        <b>Up to date details</b>
                        <p>Perform updates yourself</p>
                    </li>
                    <li>
                        <b>Specialisation Listing</b>
                        <p>List your Specialties</p>
                    </li>
                    <li>
                        <b>Special Interests</b>
                        <p>List your Special Interests</p>
                    </li>
                </ul>
            </div>
            <div className="col-md-2  bounceIn" data-wow-delay="2.25s">
                <img src={require('../Home/hands.png')} alt="Specialist and General Practice Referrals" width="100%" />
            </div>
            <div className="col-md-5   fadeInLeft" data-wow-delay="1.5s">
                <h3 className="secondary">General Practice Referrals</h3>
                <p>Access an in depth directory. The data is cross connected so that you can search for Special Interests, Clinics, Hospitals, Location, Specialty and much more.</p>
                <br />
                <Link to="/pricing" className="btn secondary"><i className="fa fa-check" />Apply to Use</Link>
                <ul className="secondary">
                    <li>
                        <b>Comprehensive Directory</b>
                        <p>Find the right specialist for your patient</p>
                    </li>
                    <li>
                        <b>Contact Specialists Directly</b>
                        <p>Mobiles may be listed for emergencies</p>
                    </li>
                    <li>
                        <b>Up to Date</b>
                        <p>Avoid mistaken referrals</p>
                    </li>
                    <li>
                        <b>Favourite System</b>
                        <p>Save preferred specialist</p>
                    </li>
                    <li>
                        <b>Location Aware</b>
                        <p>Find results close to you</p>
                    </li>    
                </ul>
            </div>
        </div>

        
    </div>  

const Services = () =>
    <div className="services">
        <div className="container">
            <div className="row">
                <div className="col-md-4">
                    <div className="wow fadeIn"  data-wow-delay="0.2s">
                        <img src={require('./hands-old.png')} alt="Reliable GPbook Directory" height="64" />    
                        <h3>Reliable</h3>
                        <div className="tagline">20 Year Specialist Database</div>
                    </div>
                    <img src={require("./screenshot-reliable.jpg")} className="screenshot wow fadeIn" data-wow-delay="0.2s"  alt="GPbook Reliable" width="100%" />
                    <p className="wow fadeIn"  data-wow-delay="0.4s">
                        The same great directory you know and trust, made better. The medical directory has been established for over 20 years, operated by Stephen Hodby in collaboration with thousands of Specialists around Western Australia.
                    </p>
                </div>
                <div className="col-md-4">
                    <div className="wow fadeIn"  data-wow-delay="0.4s">
                        <img src={require('./bolt-secondary.png')} alt="Fast GPbook Directory"  height="64" />    
                        <h3 className="secondary ">Fast</h3>
                        <div className="tagline">Lightning Fast Searches</div>
                    </div>
                    
                    <img src={require("./screenshot-fast.jpg")} className="screenshot wow fadeIn" data-wow-delay="0.4s" alt="GPbook Fast" width="100%" />
                    <p className="wow fadeIn"  data-wow-delay="0.6s">
                        With a busy day, this directory wont slow down your work. With the addition of community favourites, you can instantly see what other doctors in your clinic recommend as their preferred specialist to refer patients to.
                    </p>
                </div>
                <div className="col-md-4">
                    <div className="wow fadeIn"  data-wow-delay="0.6s">
                        <img src={require('./hat.png')} alt="Smart GPbook Directory" height="64" />    
                        <h3>Smart</h3>
                        <div className="tagline">We Have Made it Smart</div>
                    </div>
                    <img src={require("./screenshot-smart.jpg")} className="screenshot wow fadeIn"  data-wow-delay="0.6s" alt="GPbook Smart" width="100%" />
                    <p className="wow fadeIn"  data-wow-delay="0.8s">
                        You can search medical categories, special interests, locations and fields instantly. All of this is arranged by location and distance from your clinic or your patients address, allowing you to star your favourited specialist. You can even create your own list of favourite specialists and share it.
                    </p>
                </div>
                
            </div>
        </div>
        <div className="container">
            <Link to="/features" className="btn base wow bounceIn" data-wow-delay="0.6s" >Read More about our Features</Link>
        </div>
    </div>    

 

export default Home;


// WEBPACK FOOTER //
// ./src/Containers/Home/Home.js